export default __webpack_public_path__ + "static/media/download.4ef24df7.svg";